module.exports = __webpack_public_path__ + "static/media/Admission_form.0330c959.pdf";